import { render, staticRenderFns } from "./DeleteScreenModal.vue?vue&type=template&id=46f33524&scoped=true"
import script from "./DeleteScreenModal.vue?vue&type=script&lang=js"
export * from "./DeleteScreenModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteScreenModal.vue?vue&type=style&index=0&id=46f33524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f33524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f33524')) {
      api.createRecord('46f33524', component.options)
    } else {
      api.reload('46f33524', component.options)
    }
    module.hot.accept("./DeleteScreenModal.vue?vue&type=template&id=46f33524&scoped=true", function () {
      api.rerender('46f33524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/DeleteScreenModal.vue"
export default component.exports